import React from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import KanbanBoard from "./KanbanBoard";

const KanbanContainer = () => (
  <DashboardLayout disableAnimation>
    <KanbanBoard />
  </DashboardLayout>
);

export default KanbanContainer;
